import React from 'react';
import { PawPrintIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-forest-900 text-cream-200/60" data-id="element-30" data-mp="3gezdb400vr15">
      <div className="mx-auto max-w-4xl px-5 py-10 text-center" data-id="element-31" data-mp="3ggkal1dq1o2p">
        <p className="flex items-center justify-center gap-2 font-display text-lg font-bold text-cream-100" data-id="element-32" data-mp="32ovvcp86ejhi">
          <PawPrintIcon className="h-5 w-5 text-clay-400" aria-hidden="true" data-id="element-33" data-mp="36q94b86kf2sn" />
          Longevidad Canina
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-xs leading-relaxed" data-id="element-34" data-mp="3uftkxkf8xnyr">
          Este material es de carácter educativo y no sustituye el diagnóstico ni el tratamiento de
          un médico veterinario. Los resultados pueden variar según la raza, la edad y el estado de
          salud de cada perro.
        </p>
        <p className="mt-4 text-xs" data-id="element-35" data-mp="3qf9raqtvt2hd">
          © {new Date().getFullYear()} Megapack: Conociendo la Longevidad Canina. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}